import {useEffect, useRef, useState} from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import {getClassroomsQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import {history} from 'client/history';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

const BASE_ROUTE = '/home';
const ASSIGNMENTS_ROUTE = `${BASE_ROUTE}/assignments`;
const WELCOME_ROUTE = `${BASE_ROUTE}/welcome`;

// Prevents the user from ending up on the wrong route when they have/don't have classrooms
// or if they try to access a class they are no longer in.
export default function useMaybeRedirectUser(classroomId: string | undefined, pathname: string) {
  const studentId = useStudentDashboard((state) => state.student?.getId());
  const hasRun = useRef(false);
  const isBaseRoute = /\/home\/?$/.test(pathname);
  const isWelcomeRoute = pathname.startsWith(WELCOME_ROUTE);

  const [isMaybeRedirectingUser, setIsMaybeRedirectingUser] = useState(true);

  useEffect(() => {
    if (!hasRun.current && studentId !== undefined) {
      getClassroomsQuery(studentId)
        .getResourcePromise()
        .then((classrooms) => {
          hasRun.current = true;

          const hasClassrooms = classrooms.size > 0;
          const hasCurrentClassroom =
            classrooms.find((classroom) => classroom.getId() === classroomId) !== undefined;

          if (!hasClassrooms && (!isWelcomeRoute || isBaseRoute)) {
            history.replace(WELCOME_ROUTE);
          } else if (
            hasClassrooms &&
            (isWelcomeRoute || isBaseRoute || (classroomId !== undefined && !hasCurrentClassroom))
          ) {
            history.replace(ASSIGNMENTS_ROUTE);
          }
        })
        .catch(() => {
          addGenericErrorToast();
        })
        .finally(() => {
          setIsMaybeRedirectingUser(false);
        });
    }
  }, [classroomId, isBaseRoute, isWelcomeRoute, pathname, studentId]);

  return isMaybeRedirectingUser;
}
